<template>
  <div class="mr-4 ml-4" style="width: 90vw;">
    <div v-if="title" class="row mb-2 w-100 text-primary d-flex justify-content-center" style="font-size: 1rem;">
      <h1><b class="mr-1">{{title}}</b></h1>
      <p v-if="text">{{text}}</p>
      <img class="image" v-if="text && image" :src="image"/>
    </div>

    <div class="row w-100">
      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div class="row text-left w-100">
      <div class="card pb-2 text-primary">
        <div class="card-body">
          <div class="col-lg w-100 text-primary mb-4" style="font-size: 1rem;">
            <b class="mr-1">Instrucciones: </b> {{instructions}}
          </div>
          <div class="col-lg w-100" v-for="question in questionsToRender" :key="`question-${question.index}`">
            <h5 class="text-primary mt-4">
              {{question.index + 1}}.- {{question.question}}
              <p v-if="question.questionText" style="font-size: 1rem;">
                {{question.questionText}}
              </p>
              <br v-if="question.questionImage">
              <img class="image" v-if="question.questionImage" :src="question.questionImage" width="400"/>
              <i v-if="isEvaluated && !question.isCorrect" class="fas fa-times text-danger"></i>
              <i v-if="isEvaluated && question.isCorrect" class="fas fa-check text-success"></i>
            </h5>
            <div v-for="(option, index) in question.options" :key="`${option.option}-${index}`">
              <n-radio v-model="question.selectedAnswer" :label="option.option">{{option.option}}</n-radio>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row w-100">
      <alert
        type="danger"
        dismissible
        @dismiss="errorMessage = ''"
        :isVisible="errorMessage ? true : false"
      >
        {{errorMessage}}
      </alert>
    </div>

    <div class="row w-100">
      <alert
        type="success"
        dismissible
        @dismiss="successMessage = ''"
        :isVisible="successMessage ? true : false"
      >
        {{successMessage}}
      </alert>
    </div>

    <div class="row w-100">
      <div class="col-lg text-center">
        <button class="btn btn-primary w-50" @click="evaluate()" v-if="!isEvaluated">
          Evaluar
        </button>
        <button class="btn btn-primary w-50" @click="restart()" v-else>
          <i class="fas fa-undo"></i>
          Reiniciar
        </button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'quiz',
  interval: null,
  startInterval: null,
  props: {
    instructions: {
      type: String,
      default: 'Responde las siguientes preguntas.'
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      successMessage: '',
      errorMessage: '',
      isEvaluated: false,
      currentKeyWord: null,
      questionsToRender: null,
      modals: {
        classic: false
      }
    }
  },
  methods: {
    init() {
      this.questionsToRender = this.questions.map((question, index) => ({
        ...question,
        index,
        selectedAnswer: '',
        isCorrect: false
      }));
    },
    restart() {
      this.successMessage = '';
      this.errorMessage = '';
      this.isEvaluated = false;
      this.questionsToRender = null;
      this.init();
    },
    evaluate() {
      this.successMessage = '';
      this.errorMessage = '';

      let isInvalid = this.questionsToRender.some(question => (!question.selectedAnswer));

      if (isInvalid) {
        this.errorMessage = '¡Ups!, aún no terminas, reponde todas las preguntas.';
        return;
      }

      this.questionsToRender = this.questionsToRender.map(question => {
        let correctOptions = question.options.filter(option => option.isCorrect);
        question.isCorrect = correctOptions.some(correctAnswer => question.selectedAnswer == correctAnswer.option);
        return question;
      });

      let correctAnswers = this.questionsToRender.filter(question => question.isCorrect);

      this.successMessage = `¡Has terminado!, respondiste ${correctAnswers.length} correctas de ${this.questionsToRender.length}`;

      this.isEvaluated = true;
    }
  }
}
</script>

<style scoped>
.btn-success {
  background-color: rgba(24, 206, 15, 0.8);
}

.btn-outline-primary {
  border: 1px solid #023F85 !important;
  background-color: white;
  color: #023F85;
}

.btn-outline-primary:hover {
  border: 1px solid #023F85 !important;
  background-color: #023F85;
  color: white;
}
</style>
